/**
 * Get available Status transitions for current Status
 *
 * @returns {string[]} - allowed status transitions
 */
export function getAccountBadgeValidStatusChanges(status) {
    if (status === 'valid') {
        return ['expired', 'revoked', 'reissueNeeded'];
    }
    return [];
}
